import LoadingScreen from 'components/atoms/loading-screen/LoadingScreen'
import withModal from 'lib/helpers/hoc/withModal'
import React from 'react'

const LoadingModal = () => {
    return (
        <div className='relative py-20'>
            <LoadingScreen />
        </div>
    )
}

export default withModal(LoadingModal)